import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Modal, Button } from 'react-bootstrap'
import { hideAlert } from '../../reducer/alertSlice'

const Alert = () => {
	const dispatch = useDispatch()
	const { value, msg, func } = useSelector(state => state.alert)

	const handleClose = () => {
		func?.()
		dispatch(hideAlert())
	}

	return (
		<Modal
			show={value}
			centered
			size="sm"
			className="custom-modal"
			onHide={handleClose}
		>
			<Modal.Body className="body">{msg}</Modal.Body>
			<Modal.Footer>
				<Button variant="primary" className="confirm-btn" onClick={handleClose}>
					확인
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default Alert